function SharedCart(map = false) {
    let SKU_VARIANT_MAP = map;
    const BACKEND_URL_BASE = 'https://epoch-inventory.genielab.uk/api';
    const GLOBAL_CONFIG = {
        MASTER_STORE_URL: 'https://epoch-sports-llc.myshopify.com/',
        MASTER_STORE_GRAPHQL_URL: 'https://epoch-sports-llc.myshopify.com/api/2022-10/graphql.json',
        MASTER_STORE_TOKEN: '551050ef526ceea92c7449f9c9f67808'
    };
    const CART_COOKIE_NAME = "cartId";
    const CART_COOKIE_VALID_DAYS = 13;
    let userIpAddress = false;
    let serverCartId = false;
    let localCartId = false;
    let cartItems;
    let cartButtonOriginalText = 'Add to cart'
    let SHARED_CART_DRAWER, SHARED_CART_PAGE;
    this.getCartItems = ()=> {
        return cartItems;
    }
    const CUSTOM_EVENTS = {
        CartNotification_error: (message) => {
            try {
                document.documentElement.dispatchEvent(
                    new CustomEvent("cart-notification:show", {
                        bubbles: true,
                        cancelable: true,
                        detail: {
                            status: "error",
                            error: message,
                        },
                    })
                );
            } catch (error) {
                console.log(error);
            }
        },
        globalVariant_add: (item) => {
            try {
                document.documentElement.dispatchEvent(
                    new CustomEvent("globalVariant:add", {
                        bubbles: true,
                        detail: item
                    })
                );
            } catch (error) {
                console.log(error);
            }
        },
        globalcartID_updated: () => {
            try {
                document.documentElement.dispatchEvent(
                    new CustomEvent("globalcartID:updated", {
                        bubbles: true,
                    })
                );
            } catch (error) {
                console.log(error);
            }
        },
    };
    this.storePayloadOnServer = async (payload) => {
        try {
            const formData = new FormData();
            formData.append('payload', payload);
            const response = await fetch(`${BACKEND_URL_BASE}/set-payload`, {
                method: "POST", // *GET, POST, PUT, DELETE, etc.
                mode: "cors", // no-cors, *cors, same-origin
                cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
                credentials: "same-origin", // include, *same-origin, omit
                redirect: "follow", // manual, *follow, error
                referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
                body: formData
            });

            const r = await response.json();
            return r;
        } catch (error) {
            console.log(error);
            return false;
        }
    }
    this.upsellAddOnSetup = () => {
        document.addEventListener('upsell:added', async (e) => {
            console.log('upsell add to cart clicke');
            //return false;
            const detail = e.detail;
            const comboVariant = detail.comboVariant;
            const variant = detail.variant;
            const comboProduct = detail.comboProduct;
            const max_qty = detail.maxQty;
            const price = detail.price;
            const originalPrice = detail.originalPrice;
            const attributes = [
                {key: "_upsell_product_id", value: comboProduct},
                {key: "_upsell_variant_id", value: comboVariant},
                {key: "_upsell_price", value: price + ""},
                {key: "_upsell_originalprice", value: originalPrice + ""},
                {key: "_upsell_qty", value: max_qty + ""},
            ];
            $.LoadingOverlay('show');
            const cartData = await this.addProductToCart_Request(
                variant,
                1,
                localCartId,
                attributes
            );
            $.LoadingOverlay('hide');

            if(SHARED_CART_PAGE !== undefined){
                SHARED_CART_PAGE.setCartItems(cartItems);
            }else{
                SHARED_CART_DRAWER.setCartItems(cartItems);
            }
            this.calculateCartItems();
            const CartTotalAmount = `${parseFloat(
                cartData?.cartLinesAdd?.cart?.estimatedCost?.subtotalAmount?.amount
            ).toFixed(2)} ${
                cartData?.cartLinesAdd?.cart?.estimatedCost?.subtotalAmount
                    ?.currencyCode
            }`;
            this.updateCheckoutButton(CartTotalAmount);
            const _item = this._findLineItem(cartData?.cartLinesAdd?.cart, variant);
            CUSTOM_EVENTS.globalVariant_add(_item);
            const drawer = document.getElementsByTagName('cart-drawer');
            if(SHARED_CART_DRAWER !== undefined) {
                if (drawer.length) {
                    drawer[0].open();
                }
            }

        });

    }
    this.bespokeProductHandler = async (xmlString) => {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(xmlString, "text/xml");
        const unitPrice = xmlDoc.querySelector('order > products > product > unitPrice').childNodes[0].nodeValue;
        console.log(unitPrice);
        const bespokeSku = xmlDoc.querySelector('order > products > product > cartProductKey').childNodes[0].nodeValue;
        const variantId = await this.getVariantData(bespokeSku);
        const nodes = xmlDoc.querySelectorAll("order > products > product > attributes > attribute");
        const attributes = [
            { "key" : "_productType", "value" : "bespoke"},
            { "key" : "_productPrice", "value" : "" + unitPrice},
        ];
        for (let i in nodes) {
            try {
                const key = nodes[i].getElementsByTagName("name")[0].childNodes[0].nodeValue;
                const value = nodes[i].getElementsByTagName("value")[0].childNodes[0].nodeValue;
                if (value && value.length) {
                    attributes.push({"key": key, "value": value})
                }
            } catch (e) {

            }
        }
        //console.log(bespokeSku,attributes, variantId);
        if (variantId) {
            SKU_VARIANT_MAP[bespokeSku] = variantId;
            $.LoadingOverlay('show');
            const resp = await this.storePayloadOnServer(xmlString);
            if (resp && resp.status) {
                attributes.push({"key": "_payload_url", "value": `${BACKEND_URL_BASE}/get-payload/${resp.id}`})
            }
            const cartData = await this.addProductToCart_Request(
                variantId,
                1,
                localCartId,
                attributes
            );
            $.LoadingOverlay('hide');
            SHARED_CART_DRAWER.setCartItems(cartItems);
            this.calculateCartItems();
            const CartTotalAmount = `${parseFloat(
                cartData?.cartLinesAdd?.cart?.estimatedCost?.subtotalAmount?.amount
            ).toFixed(2)} ${
                cartData?.cartLinesAdd?.cart?.estimatedCost?.subtotalAmount
                    ?.currencyCode
            }`;
            this.updateCheckoutButton(CartTotalAmount);
            const _item = this._findLineItem(cartData?.cartLinesAdd?.cart, variantId);
            CUSTOM_EVENTS.globalVariant_add(_item);
            const drawer = document.getElementsByTagName('cart-drawer');
            if (drawer.length) {
                drawer[0].open();
            }

        }
    }
    this.changeButtonStatus = (productForm, isLoading = true)=> {
        const submitButton = productForm[0].querySelector('[type="submit"]');
        if(submitButton) {
            if(isLoading) {
                submitButton.setAttribute('aria-disabled', true);
                submitButton.classList.add('loading');
                productForm[0].querySelector('.loading-overlay__spinner').classList.remove('hidden');
            }else{
                submitButton.setAttribute('aria-disabled', false);
                submitButton.classList.remove('loading');
                productForm[0].querySelector('.loading-overlay__spinner').classList.add('hidden');
            }
        }
    }
    this.setupListeners = () => {
        document.addEventListener('cart-notification:show', async (event) => {

            if(event.detail && event.detail.error ) {
                $.toast({
                    heading: 'Cart Error',
                    text: event.detail.error,
                    position: 'top-center',
                    showHideTransition: 'fade',
                    icon: 'error',
                    hideAfter:5000,
                    stack: false
                });
            }
        })
        document.addEventListener("checkout:clicked", async (event) => {
            $.LoadingOverlay('show');

            if(event.detail.note.length){
                const r = await this.updateCartNote_Request(event.detail.note, localCartId);
                if(!r){
                    console.log('update note failed');
                    return false;
                }
            }
            //activate loader
            if(event.detail.checkoutUrl.length){
                window.location.href = event.detail.checkoutUrl;
            }
        })
        document.addEventListener("bespokeProduct:added", async (event) => {
            if (event.detail && event.detail.length > 0) {
                $.LoadingOverlay('show');
                await this.bespokeProductHandler(event.detail);
                $.LoadingOverlay('hide');
            }
        });
        document.addEventListener("variant:updated", async (event) => {
            try {

                const _item = this._findLineItem2(cartItems.cart, event.detail.id);
                const finalQty = event.detail.quantity;
                $.LoadingOverlay('show');
                const cartData = await this.updateProductToCart_Request(
                    event.detail.id,
                    finalQty,
                    localCartId,
                    event.detail.attributes
                );
                $.LoadingOverlay('hide');
                if (cartData) {


                    if (SHARED_CART_PAGE !== undefined) {
                        SHARED_CART_PAGE.setCartItems(cartItems);
                    }else{
                        SHARED_CART_DRAWER.setCartItems(cartItems);
                    }
                    if (event.detail.quantity === 0) {


                        if (SHARED_CART_PAGE !== undefined) {
                            await SHARED_CART_PAGE.removeItem(_item);
                        }else{
                            await SHARED_CART_DRAWER.removeItem(_item);
                        }
                    }
                    if (finalQty) {
                        console.log('newQty', finalQty);
                        const _it = this._findLineItem2(cartItems.cart, event.detail.id);

                        if (SHARED_CART_PAGE !== undefined) {
                            await SHARED_CART_PAGE.addItem(_it);
                        }else{
                            await SHARED_CART_DRAWER.addItem(_it);
                        }
                    }

                    if (SHARED_CART_PAGE !== undefined) {
                        await SHARED_CART_PAGE.refreshItems();
                        await SHARED_CART_PAGE.toggleVisualElements();
                    }else{
                        await SHARED_CART_DRAWER.refreshItems();
                        await SHARED_CART_DRAWER.toggleVisualElements()
                    }
                    this.calculateCartItems();
                }else{
                    //restore cart state
                    await SHARED_CART_DRAWER.refreshItems();
                    await SHARED_CART_DRAWER.toggleVisualElements()
                    //alert("there is an error");
                }

            } catch (error) {
                console.log(error);
            }
        });
        document.addEventListener("variant:added", async (event) => {
            let cartData
            const parallelProductVariantID = SKU_VARIANT_MAP[event.detail.form.get('sku')];
            console.log('variant', event.detail.form.get('sku'), SKU_VARIANT_MAP);
            const productForm = document.getElementsByTagName('product-form');
            let submitButton = false;
            if (productForm.length) {
                this.changeButtonStatus(productForm, true);
            }
            const quantity = document.getElementsByName("quantity")[0].value;
            // console.log("quantity1 ====>",quantity1)
            $.LoadingOverlay('show');
            cartData = await this.addProductToCart_Request(
                parallelProductVariantID,
                quantity,
                localCartId
            );
            $.LoadingOverlay('hide');
            if(cartData === false){
                if (productForm.length) {
                    this.changeButtonStatus(productForm, false);
                }
                //CUSTOM_EVENTS.CartNotification_error("something went wrong. Please try again in few minutes")
                return false;
            }

            if (SHARED_CART_PAGE !== undefined) {
                SHARED_CART_PAGE.setCartItems(cartItems);
            }else{
                SHARED_CART_DRAWER.setCartItems(cartItems);
            }
            this.calculateCartItems();
            const CartTotalAmount = `${parseFloat(
                cartData?.cartLinesAdd?.cart?.estimatedCost?.subtotalAmount?.amount
            ).toFixed(2)} ${
                cartData?.cartLinesAdd?.cart?.estimatedCost?.subtotalAmount
                    ?.currencyCode
            }`;
            this.updateCheckoutButton(CartTotalAmount);
            const _item = this._findLineItem(cartData?.cartLinesAdd?.cart, parallelProductVariantID);
            //console.log(_item);
            CUSTOM_EVENTS.globalVariant_add(_item);
            if (quantity) {
                const drawer = document.getElementsByTagName('cart-drawer');
                if (drawer.length) {
                    drawer[0].open();
                }
                if (productForm.length) {
                    this.changeButtonStatus(productForm, false);
                }
            }
        });
    }
    this._findLineQuantity = (cart, variant_gid) => {
        //console.log('cart', cart);
        const lines = cart?.lines?.edges;
        if (lines) {
            for (let i in lines) {
                console.log(lines[i].node.id, '===', variant_gid)
                if (lines[i].node.id === variant_gid) {
                    return lines[i].node.quantity;
                }
            }
        }
        return false;
    }
    this._findLineItem2 = (cart, variant_gid) => {
        //console.log('sdfsdfs', cart);
        const lines = cart?.lines?.edges;
        if (lines) {
            for (let i in lines) {
              //  console.log('find2', lines[i].node.id, '===', variant_gid)
                if (lines[i].node.id === variant_gid) {
                    return lines[i];
                }
            }
        }
        return false;
    }
    this._findLineItem = (cart, variant_gid) => {
        const lines = cart?.lines?.edges;
        if (lines) {
            for (let i in lines) {
                //console.log(lines[i].node.merchandise.id, '===', variant_gid)
                if (lines[i].node.merchandise.id === variant_gid) {
                    return lines[i];
                }
            }
        }
        return false;
    }
    this.init = async () => {

        try {
            this.setupListeners();
            const globalCartStatus = await this.main();
            if (!globalCartStatus) {
                console.log("there is problem in fetching ");
                return false;
            }

            this.calculateCartItems();

            if (document.location.href.includes("/cart")) {
                //console.log('on cart page');
                // Trick to remove cart icon click listener preventing cart drawer opening
                var ele = document.querySelector('#cart-icon-bubble')
                ele.outerHTML = ele.outerHTML;
                SHARED_CART_PAGE = new SharedCartPage();
                try {
                    //document.querySelector('.cart-items').css.display = 'none';
                    SHARED_CART_PAGE.setCartItems(cartItems);
                    await SHARED_CART_PAGE.init();
                    document.querySelector('#loadingspinner').remove();
                } catch (error) {
                    console.log(error)
                    if (error instanceof ReferenceError) {
                        await new Promise((resolve) => setTimeout(resolve, 1500));
                        //await this.display_main_cart_items();
                    }
                }

            }else {
                SHARED_CART_DRAWER = new SharedCartDrawer();
                SHARED_CART_DRAWER.setCartItems(cartItems);
                await SHARED_CART_DRAWER.init();
            }
            document.addEventListener("globalVariant:add", async (e) => {
               // console.log("globalVariant:add", e);
                //await new Promise((resolve) => setTimeout(resolve, 1000));
                //deactivateCartLoader();

                if (SHARED_CART_PAGE !== undefined) {

                    await SHARED_CART_PAGE.refreshItems();
                    //await SHARED_CART_PAGE.addItem(e.detail);
                    await SHARED_CART_PAGE.toggleVisualElements();
                }else{
                    console.log("shared cart page undefined")
                    await SHARED_CART_DRAWER.refreshItems();
                    //await SHARED_CART_DRAWER.addItem(e.detail);
                    await SHARED_CART_DRAWER.toggleVisualElements();
                }
                //await SHARED_CART_DRAWER.init();
            });
            this.upsellAddOnSetup();
        } catch (error) {
            console.log(error);
        }
    }
    this.main = async () => {
        try {
            this.toggleAddToCartButtonStatus();
            await this.getUserIpaddress();
            serverCartId = await this.getCartIdFromServer();
           // console.log('serverCartId', serverCartId);
            localCartId = this.getCookie(CART_COOKIE_NAME);
            if (serverCartId === 'false') serverCartId = false;
            let cartIdResolved = true;
            let tempCartId = false;
            let conflictedCartId2 = false;
            if (!serverCartId && !localCartId) {
                //no reference found
                cartIdResolved = false;
               // console.log('No cart id found');
            } else {
                if (!serverCartId && localCartId) {
                    // reference is found in cookies
                    tempCartId = localCartId;
                    await this.storeCartIdOnServer(tempCartId, userIpAddress);
                    cartIdResolved = true;
                   // console.log('Cart id found in cookie');
                } else if (!localCartId && serverCartId) {
                    // reference is found in firebase
                    tempCartId = serverCartId
                    cartIdResolved = true;
                  //  console.log('Cart id found on server');
                } else if (serverCartId && localCartId) {
                    // reference is found in both
                   // console.log('Cart id found both in server and cookie');
                    if (serverCartId === localCartId) {
                        //both are same
                        tempCartId = localCartId;
                        cartIdResolved = true;
                      //  console.log('Cart id found is same on both server and in cookie');
                    } else {
                        // both are not same
                        tempCartId = localCartId;
                        conflictedCartId2 = serverCartId;
                       // console.log('Cart id found but conflicted');
                    }
                }
            }
            if (cartIdResolved) {
                //validate cart
                const globalCartID__Status = await this.fetchCartLines(tempCartId);
                if (conflictedCartId2) {
                    //we have got 2 cart ids. Let's validate the second one
                    const conflictedGlobalCartID__Status = await this.fetchCartLines(conflictedCartId2);
                    if (conflictedGlobalCartID__Status) {
                        //second cart id is valid
                        if (globalCartID__Status) {
                            //first cart id is also valid. We have to merge the cart itmes now

                            const globalCartID_Firebase_ProductsList = this.creatProductList(
                                conflictedGlobalCartID__Status
                            );
                            const globalCartID_Cookies_ProductsList = this.creatProductList(
                                globalCartID__Status
                            );

                            if (globalCartID_Cookies_ProductsList.length === 0) {
                                console.log(
                                    "global cart id that exist in cookies doesn't have any item then replace it with global cart id that stored in firebase"
                                );

                            } else {

                                // get products from local cart that not appear in global cart
                                const productMustAdded = this.filterTwoReferences(
                                    globalCartID_Cookies_ProductsList,
                                    globalCartID_Firebase_ProductsList
                                );

                                // if there is no update need to be maked in globalCartID_Firebase then set it on cookies
                                if (productMustAdded.length === 0) {
                                    console.log(
                                        "there are no updates need to be made in globalCartID_Firebase then set it on cookies "
                                    );
                                    //setCookie(CART_COOKIE_NAME, globalCartID_Firebase, CART_COOKIE_VALID_DAYS);

                                } else {
                                    // update global cart
                                    console.log(
                                        "there are updates need to be maked in globalCartID_Firebase then set it on cookies "
                                    );
                                    await this.updateCart(productMustAdded, conflictedCartId2);
                                }
                            }

                            tempCartId = conflictedCartId2;
                            cartIdResolved = true;

                        }
                    }
                } else if (!globalCartID__Status) {
                    cartIdResolved = false;
                    tempCartId = false;
                }
            }
            if (cartIdResolved) {
                localCartId = tempCartId;
                this.setCookie(CART_COOKIE_NAME, tempCartId, CART_COOKIE_VALID_DAYS);
                this.toggleAddToCartButtonStatus();
                return true;
            } else if (!tempCartId) {
                return await this.createNewCartAndStoreIt(userIpAddress);

            }
        } catch (e) {
            console.log('SharedCartError in initialization', e.message);
        }
    }
    this.calculateCartItems = () => {
        try {
            let count = 0;
            cartItems?.cart?.lines?.edges?.forEach((element) => {
                count = count + element?.node?.quantity;
            });
            CartIcon_quantity = count;
            const CartIcon = document.getElementsByClassName("cart-count-bubble");
            if (CartIcon.length > 0) {
                const cartCounterElement = CartIcon[0].querySelector(".cart-count-bubble > span[aria-hidden]");
                const cartCounterHiddenElement = CartIcon[0].querySelector(".cart-count-bubble > span[class='visually-hidden']");
                if (cartCounterElement) {
                    cartCounterElement.innerText = CartIcon_quantity;
                }
                if (cartCounterHiddenElement) {
                    cartCounterHiddenElement.innerText = CartIcon_quantity + ' item';
                }

            } else {
                const ele = document.createElement('div');
                ele.classList.add('cart-count-bubble');
                const child_1 = document.createElement('span');
                child_1.setAttribute('aria-hidden', true);
                child_1.innerText = CartIcon_quantity;
                const child_2 = document.createElement('span');
                child_2.classList.add('visually-hidden');
                child_2.innerText = CartIcon_quantity + ' item';
                ele.append(child_1);
                ele.append(child_2);
                const headerElement = document.getElementsByClassName('header__icon--cart');
                if (headerElement.length) {
                    headerElement[0].append(ele);
                }
            }
            return count;
        } catch (error) {
            console.log(error);
            return 0;
        }
    }
    this.updateCheckoutButton = (price) => {
        if (document.readyState !== "loading") {
            const loader_button__text = document.getElementsByClassName(
                "cart__checkout-button"
            )[0];
           // console.log(price)
            if (loader_button__text) {
                loader_button__text.innerText = "CHECKOUT $" + price;
                loader_button__text.removeAttribute('disabled');
            }
        } else {
            window.addEventListener('load', (event) => {
                const loader_button__text = document.getElementsByClassName(
                    "cart__checkout-button"
                )[0];
                console.log(price)
                if (loader_button__text) {
                    loader_button__text.innerText = "CHECKOUT $" + price;
                    loader_button__text.removeAttribute('disabled');
                }
            });
        }

    }


    this.calculatCartItems = (data) => {
        try {
            let count = 0;
            data?.cart?.lines?.edges?.forEach((element) => {
                count = count + element?.node?.quantity;
            });
            CartIcon_quantity = count;
            const CartIcon = document.getElementsByClassName("cart-count-bubble");
            if (CartIcon.length > 0) {
                const cartCounterElement = CartIcon[0].querySelector(".cart-count-bubble > span[aria-hidden]");
                const cartCounterHiddenElement = CartIcon[0].querySelector(".cart-count-bubble > span[class='visually-hidden']");
                if (cartCounterElement) {
                    cartCounterElement.innerText = CartIcon_quantity;
                }
                if (cartCounterHiddenElement) {
                    cartCounterHiddenElement.innerText = CartIcon_quantity + ' item';
                }

            } else {
                const ele = document.createElement('div');
                ele.classList.add('cart-count-bubble');
                const child_1 = document.createElement('span');
                child_1.setAttribute('aria-hidden', true);
                child_1.innerText = CartIcon_quantity;
                const child_2 = document.createElement('span');
                child_2.classList.add('visually-hidden');
                child_2.innerText = CartIcon_quantity + ' item';
                ele.append(child_1);
                ele.append(child_2);
                const headerElement = document.getElementsByClassName('header__icon--cart');
                if (headerElement.length) {
                    headerElement[0].append(ele);
                }
            }
            return count;
        } catch (error) {
            console.log(error);
            return 0;
        }
    }

    let CartIcon_quantity = 0;

    this.getUserIpaddress = async (retryCount = 0) => {
        if (retryCount > 5) return false;
        const url = '/get-ip';
        try {
            const response = await fetch(`${BACKEND_URL_BASE}/get-ip`);
            if (response.status !== 200) {
                return this.getUserIpaddress(retryCount + 1);
            }
            const r = await response.json();
            userIpAddress = r.ip;
            return true;

        } catch (error) {
            console.log(error);
            return this.getUserIpaddress(retryCount + 1);
        }
    };

    this.storeCartIdOnServer = async (cartId) => {
        try {
            localCartId = cartId;
            this.setCookie(CART_COOKIE_NAME, cartId, CART_COOKIE_VALID_DAYS);
            const formData = new FormData();
            formData.append('ip_address', userIpAddress);
            formData.append('cart_id', cartId);
            const response = await fetch(`${BACKEND_URL_BASE}/save-cart`, {
                method: "POST", // *GET, POST, PUT, DELETE, etc.
                mode: "cors", // no-cors, *cors, same-origin
                cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
                credentials: "same-origin", // include, *same-origin, omit
                redirect: "follow", // manual, *follow, error
                referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
                body: formData
            });

            const r = await response.json();
            return r.status;
        } catch (error) {
            console.log(error);
            return false;
        }
    }
    this.getCartIdFromServer = async () => {

        try {
            const response = await fetch(`${BACKEND_URL_BASE}/get-cart/` + userIpAddress);
            if (!response.status) {
                console.log("there is no cartid linked by that ipAddress");
                return false;
            }
            r = await response.json();
            if (r.cart_id === 'false') return false;
            console.log(r);
            return r.cart_id;
        } catch (error) {
            console.log(error);
            return false;
        }
    }
    this.createNewCartAndStoreIt = async () => {
        try {
            const newCartID = await this.createCart();
            this.setCookie(CART_COOKIE_NAME, newCartID, CART_COOKIE_VALID_DAYS);
            localCartId = newCartID;
           // console.log("new cart id stored in cookies");
            await this.storeCartIdOnServer(newCartID);
            this.toggleAddToCartButtonStatus();
            return true;
        } catch (error) {
            console.log(error);
            return false;
        }
    }
    this.toggleAddToCartButtonStatus = async () => {
        const productForm = document.getElementsByTagName('product-form');
        const cartBtn = $('.product-form__submit');
        if(!cartBtn.hasClass('loading')){
            cartBtn.addClass('loading');
            productForm[0].querySelector('.loading-overlay__spinner').classList.remove('hidden');
            cartButtonOriginalText = cartBtn.text();
            /*cartBtn.text("Please wait")*/
            cartBtn.prop('disabled', true);
        }else{
            cartBtn.removeClass('loading');
            productForm[0].querySelector('.loading-overlay__spinner').classList.add('hidden');
            /*cartBtn.text(cartButtonOriginalText)*/
            cartBtn.prop('disabled', false);
        }
    }
    this.createCart = async () => {
        try {
            const Body = `
        mutation cartCreate  {
          cartCreate {
            cart {
              discountCodes{code}
              id
              checkoutUrl
            }
            userErrors {
              code
              field
              message
            }
          }
        }
      `;
            const data = await this.masterGraphqlPostRequest(Body);
            console.log(data);
            if (data?.data?.cartCreate?.userErrors.length !== 0) {
                CUSTOM_EVENTS.CartNotification_error("Something went wrong. Please contact support!");
                console.log(data);
                return false;
            }
            cartItems = data?.data;
            return data?.data?.cartCreate?.cart?.id;
        } catch (error) {
            console.log(error);
            return false;
        }
    };
    this.creatProductList = (cartData) => {
        try {
            let productList = [];
            cartData.data.cart.lines.edges.map((item) => {
                productList.push({
                    attributes: item.node.attributes,
                    merchandiseId: item.node.merchandise.id,
                    quantity: parseInt(item.node.quantity),
                });
            });
            return productList;
        } catch (error) {
            console.log(error);
            return false;
        }
    }
    this.filterTwoReferences = (arr1, arr2) => {
        try {
            let res = [];
            res = arr1.filter((el) => {
                return !arr2.find((element) => {
                    return element.merchandiseId === el.merchandiseId;
                });
            });
            return res;
        } catch (error) {
            console.log(error);
            return [];
        }
    }
    this.getVariantData = async (sku) => {
        console.log(sku);
        try {
            const Body = `{products(first: 1, query: "${sku}") {
    edges {
      node {
        variants(first: 1) {
          edges {
            node {
              id
            }
          }
        }
      }
    }
  }
}`;
            const data = await this.masterGraphqlPostRequest(Body);

            if (data?.data) {
                return data.data.products.edges[0].node.variants.edges[0].node.id;
            }
            CUSTOM_EVENTS.CartNotification_error("Something went wrong. Please contact support!");
            return false;
        } catch (error) {
            CUSTOM_EVENTS.CartNotification_error("Something went wrong. Please contact support!");
            console.log(error)
            return false
        }
    }

    this.masterGraphqlPostRequest = async (query = ``, Variables = {}) => {
        try {
            const result = await fetch(
                GLOBAL_CONFIG.MASTER_STORE_GRAPHQL_URL,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Shopify-Storefront-Access-Token":
                        GLOBAL_CONFIG.MASTER_STORE_TOKEN,
                        Accept: "application/json",
                    },
                    body: JSON.stringify({
                        query: query,
                        variables: Variables,
                    }),
                }
            );
            return await result.json();
        } catch (error) {
            console.log(error)
            return []
        }

    }

    this.updateCart = async (items, cartID) => {
        console.log('I m in updateCart ');
        try {
            const Body = `
                        mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
                          cartLinesAdd(cartId: $cartId, lines: $lines) {
                            cart {
                              id
                              checkoutUrl
                              discountCodes{code}
                              cost {                    
                                  subtotalAmount {
                                    amount
                                    currencyCode
                                  }
                                  
                                }
                              estimatedCost {
                                subtotalAmount {
                                  amount
                                  currencyCode
                                }
                              }
                              lines(first: 100) {
                                edges {
                                  node {
                                    id
                                    quantity
                                    attributes {
                                      key
                                      value
                                    }
                                   discountAllocations {
                                        discountedAmount {
                                            amount
                                            currencyCode
                                        }
                                    }
                                    sellingPlanAllocation {
                                        checkoutChargeAmount {
                                            amount
                                            currencyCode
                                        }
                                        sellingPlan {
                                            name
                                            priceAdjustments {
                                                adjustmentValue
                                            }
                                        }
                                    }
                                    cost {
                                      amountPerQuantity {
                                        amount
                                        currencyCode
                                      }
                                      subtotalAmount {
                                        amount
                                        currencyCode
                                      }
                                      totalAmount {
                                        amount
                                        currencyCode
                                      }
                                    }
                                    estimatedCost {
                                      subtotalAmount {
                                        amount
                                        currencyCode
                                      }
                                    }
                                    merchandise {
                                      ... on ProductVariant {
                                        id
                                        sku
                                        image {
                                          url
                                        }
                                        priceV2 {
                                          amount
                                        }
                                        product {
                                          vendor
                                          title
                                          handle
                                          onlineStoreUrl
                                        }
                                        selectedOptions {
                                          name
                                          value
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                        }
                      }
                    `;

            const Variables = {
                cartId: cartID,
                lines: items,
            };

            const data = await this.masterGraphqlPostRequest(Body, Variables);
            if (!data?.data?.cartLinesAdd?.cart?.lines) {
                CUSTOM_EVENTS.CartNotification_error("Something went wrong. Please contact support!");
                console.log(
                    "something wrong in getAllCartItems() global that fetch all items from global cart"
                );
                console.log(data);
                return false;
            }
            cartItems = data?.data?.cartLinesAdd;
            return data?.data?.cartLinesAdd;
        } catch (error) {
            console.log(error);
            return false;
        }
    }
    this.updateCartNote_Request = async (note, cartId) => {
        try {
            const Body = `mutation updateCartNote($cartId: ID!, $note: String!) {
  cartNoteUpdate(cartId: $cartId, note: $note) {
    cart {
      id
      note
      
    }
    userErrors {
      field
      message
    }
  }
}`;
            const variables = {
                "cartId": cartId,
                "note": note
            }
            const res = await this.masterGraphqlPostRequest(Body, variables);
            return !!(res && res.data);

        } catch (e) {
            CUSTOM_EVENTS.CartNotification_error("Something went wrong. Please contact support!");
            console.error(e.message);
            return  false;
        }
    }
    this.addProductToCart_Request = async (variantID, quantity, cartID, custom_option = []) => {
        try {
            const Body = `
                    mutation cartLinesAdd($lines: [CartLineInput!]!, $cartId: ID!) {
                      cartLinesAdd(lines: $lines, cartId: $cartId) {
                        cart {
                          id
                          discountCodes{code}
                            checkoutUrl
                            lines(first:100) {
                              edges {
                                node {
                                  id
                                  quantity
                                  attributes{
                                    key
                                    value
                                  }
                                  discountAllocations {
                                        discountedAmount {
                                            amount
                                            currencyCode
                                        }
                                    }
                                    sellingPlanAllocation {
                                        checkoutChargeAmount {
                                            amount
                                            currencyCode
                                        }
                                        sellingPlan {
                                            name
                                            priceAdjustments {
                                                adjustmentValue
                                            }
                                        }
                                    }
                                    cost {
                                      amountPerQuantity {
                                        amount
                                        currencyCode
                                      }
                                      subtotalAmount {
                                        amount
                                        currencyCode
                                      }
                                      totalAmount {
                                        amount
                                        currencyCode
                                      }
                                    }
                                  estimatedCost {
                                    subtotalAmount {
                                      amount
                                      currencyCode
                                    }
                                  }
                                  merchandise {
                                    ... on ProductVariant {
                                      id
                                      sku
                                      image{
                                        url
                                      }
                                      priceV2{
                                        amount
                                      }
                                      product{
                                        vendor
                                        title
                                        handle
                                        onlineStoreUrl
                                      }
                                      selectedOptions{
                                        name
                                        value
                                      }
                                    }
                                  }
                                }
                              }
                            
                            }
                            cost {                    
                      subtotalAmount {
                        amount
                        currencyCode
                      }
                      
                    }
                          estimatedCost {
                            subtotalAmount {
                              amount
                              currencyCode
                            }
                          }
                        }
                        userErrors {
                          field
                          message
                          code
                        }
                      }
                    }  
                    `;
            const Variables = {
                lines: [
                    {
                        merchandiseId: variantID,
                        quantity: parseInt(quantity),
                        attributes: custom_option
                    },
                ],
                cartId: cartID,
            };

            const data = await this.masterGraphqlPostRequest(Body, Variables);
            // console.log(data);
            if (data?.data?.cartLinesAdd?.cart?.id) {
                cartItems = data.data.cartLinesAdd;
            }

            if (data?.data?.cartLinesAdd.userErrors.length !== 0) {

                console.log(
                    "error while addind item to cart : ====>",
                    data?.data?.cartLinesAdd.userErrors
                );

                // if shopify respond with cartid not existed and return a new cart id contained the item
                if (data?.data?.cartLinesAdd.userErrors[0].field[0] === "cartId") {
                    console.log("new cart ", data?.data?.cartLinesAdd?.cart?.id);
                    await this.storeCartIdOnServer(data?.data?.cartLinesAdd?.cart?.id);
                    return true;
                }

                if (data?.data?.cartLinesAdd.userErrors[0].field.includes("quantity")) {
                    console.log('qty error')
                    CUSTOM_EVENTS.CartNotification_error(
                        data?.data?.cartLinesAdd.userErrors[0].message
                    );
                }else{
                    console.log('generic error')
                    CUSTOM_EVENTS.CartNotification_error("Something went wrong. Please contact support!");
                }
                return !!data?.data?.cartLinesAdd?.cart?.id;
            }

            this.setCookie(CART_COOKIE_NAME, cartID, CART_COOKIE_VALID_DAYS);
           // console.log('addedData: ', data.data);
            return data.data || false;
        } catch (error) {
            return false;
        }
    }
    this.updateProductToCart_Request = async (variantID, quantity, cartID, custom_option) => {
        try {
            const Body = `
                        mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
                          cartLinesUpdate(cartId: $cartId, lines: $lines) {
                            cart {
                              id
                              discountCodes{code}
                                checkoutUrl
                                lines(first:100) {
                                  edges {
                                    node {
                                      id
                                      quantity
                                      attributes{
                                        key
                                        value
                                      }
                                     discountAllocations {
                                        discountedAmount {
                                            amount
                                            currencyCode
                                        }
                                    }
                                    sellingPlanAllocation {
                                        checkoutChargeAmount {
                                            amount
                                            currencyCode
                                        }
                                        sellingPlan {
                                            name
                                            priceAdjustments {
                                                adjustmentValue
                                            }
                                        }
                                    }
                                    cost {
                                      amountPerQuantity {
                                        amount
                                        currencyCode
                                      }
                                      subtotalAmount {
                                        amount
                                        currencyCode
                                      }
                                      totalAmount {
                                        amount
                                        currencyCode
                                      }
                                    }
                                      estimatedCost {
                                        subtotalAmount {
                                          amount
                                          currencyCode
                                        }
                                      }
                                      merchandise {
                                        ... on ProductVariant {
                                          id
                                          sku
                                          image{
                                            url
                                          }
                                          priceV2{
                                            amount
                                          }
                                          product{
                                            vendor
                                            title
                                            handle
                                            onlineStoreUrl
                                          }
                                          selectedOptions{
                                            name
                                            value
                                          }
                                        }
                                      }
                                    }
                                  }
                                
                                }
                                cost {                    
                              subtotalAmount {
                                amount
                                currencyCode
                              }
                              
                            }
                              estimatedCost {
                                subtotalAmount {
                                  amount
                                  currencyCode
                                }
                              }
                            }
                            userErrors {
                              field
                              message
                              code
                            }
                          }
                        }
                      `;
            const Variables = {
                lines: {
                    id: variantID,
                    quantity: parseInt(quantity),
                    attributes: custom_option,
                },
                cartId: cartID,
            };
            const data = await this.masterGraphqlPostRequest(Body, Variables);
            //console.log(data);
            if (data?.data?.cartLinesUpdate?.cart?.id) {
                cartItems = data.data.cartLinesUpdate;
            }

            if (data?.data?.cartLinesUpdate.userErrors.length !== 0) {
                CUSTOM_EVENTS.CartNotification_error("Something went wrong. Please contact support!");
                console.log(
                    "error while addind item to cart : ====>",
                    data?.data?.cartLinesUpdate.userErrors
                );

                // if shopify respond with cartid not existed and return a new cart id contained the item
                if (data?.data?.cartLinesUpdate.userErrors[0].field[0] === "cartId") {
                    console.log("new cart ", data?.data?.cartLinesUpdate?.cart?.id);
                    await this.storeCartIdOnServer(data?.data?.cartLinesUpdate?.cart?.id);
                    return true;
                }

                if (data?.data?.cartLinesUpdate.userErrors[0].field) {
                    CUSTOM_EVENTS.CartNotification_error(
                        data?.data?.cartLinesUpdate.userErrors[0].message
                    );
                }
                return data?.data?.cartLinesUpdate?.cart?.id;
            }
            return data?.data || false;
        } catch (error) {
            return false;
        }
    }
    this.getProductVariant = async (handleName, SKU) => {
        try {
            const Body = `
            query getProductVarient($SKU: String!) {
                products(first: 100 , query:$SKU) {
                    edges {
                    node {
                      id
                      title
                      handle
                      metafield(namespace:"custom",key:"lead_time"){
                        value
                      }
                      variants(first: 100) {
                        edges {
                          node {
                            sku
                            id
                          }
                        }
                      }
                    }
                  }
                }
            }
          `;
            const Variables = {
                SKU: SKU,
            };
            const data = await this.masterGraphqlPostRequest(Body, Variables);

            const variants = data.data.products?.edges[0]?.node?.variants.edges;
            const correctVariant = variants.filter((variant) => {
                return variant.node.sku === SKU;
            });
            return {
                variantID: correctVariant[0]?.node?.id,
                metafield: data.data.products?.edges[0]?.node?.metafield?.value,
            };
        } catch (error) {
            CUSTOM_EVENTS.CartNotification_error("Something went wrong. Please contact support!");
            console.log("getProductVarient =====>", error);
            return false;
        }
    }
    this.fetchCartLines = async (CartID) => {
        try {
            const Body = `
                query fetchCartLines { 
                  cart(id:"${CartID}") {
                    id
                    checkoutUrl
                    discountCodes{code}
                    lines(first:100) {
                    edges {
                      node {
                        id
                        quantity
                        attributes{
                          key
                          value
                        }
                        discountAllocations {
                            discountedAmount {
                                amount
                                currencyCode
                            }
                        }
                        sellingPlanAllocation {
                            checkoutChargeAmount {
                                amount
                                currencyCode
                            }
                            sellingPlan {
                                name
                                priceAdjustments {
                                    adjustmentValue
                                }
                            }
                        }
                        cost {
                          amountPerQuantity {
                            amount
                            currencyCode
                          }
                          subtotalAmount {
                            amount
                            currencyCode
                          }
                          totalAmount {
                            amount
                            currencyCode
                          }
                        }
                        estimatedCost {
                          subtotalAmount {
                            amount
                            currencyCode
                          }
                        }
                        merchandise {
                          ... on ProductVariant {
                            id
                            sku
                            image{
                              url
                            }
                            priceV2{
                              amount
                            }
                            product{
                              vendor
                              title
                              handle
                              onlineStoreUrl
                            }
                            selectedOptions{
                              name
                              value
                            }
                          }
                        }
                      }
                    }
                  }
                  cost {                    
                      subtotalAmount {
                        amount
                        currencyCode
                      }
                      
                    }
                  estimatedCost {
                    subtotalAmount {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            `;

            const data = await this.masterGraphqlPostRequest(Body);
            if (!data?.data?.cart?.lines) {
                CUSTOM_EVENTS.CartNotification_error("Something went wrong. Please contact support!");
                console.log(
                    "something wrong in getAllCartItems() that fetch all items from global cart"
                );
                console.log(data);
                return false;
            }
            console.log('setting cartItems', data?.data);
            cartItems = data?.data;
            return data;
        } catch (error) {
            console.log(error);
        }
    }

    this.setCookie = (cname, cvalue, exdays) => {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    this.getCookie = (cname) => {
        let name = cname + "=";
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length) !== "undefined" ? c.substring(name.length, c.length) : false;
            }
        }
        return false;
    }
}

